module.exports = __webpack_public_path__ + "static/media/iconSmsActive.c5d664c3.svg";